import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { useLocalStorage } from '@mantine/hooks';

import { UserReferrer, UserType } from 'models';
import { UserHelpers } from 'helpers/UserHelpers';

import { useCurrentUser } from 'hooks/use-current-user';

const useLocalUserInfo = () => {
    const [initialized, setInitialized] = useState(false);

    const user = useCurrentUser();
    const { query } = useRouter();

    const [_email, setEmail] = useLocalStorage<string | undefined>({
        key: UserHelpers.localStorageKey.email,
        defaultValue: user?.email ?? (query.email as string),
    });
    const email = _email !== 'undefined' ? _email : undefined;

    const [referrer, setReferrer] = useLocalStorage<UserReferrer | undefined>({
        key: UserHelpers.localStorageKey.referrer,
        defaultValue: user?.referrer ?? (query.referrer as UserReferrer),
    });
    // Other pages use a `type` query param for their own things, and earlier visits may have stored one
    const [storedType, setType] = useLocalStorage<UserType | undefined>({
        key: UserHelpers.localStorageKey.type,
        defaultValue: user?.type ?? (UserHelpers.isUserType(query.type) ? query.type : undefined),
    });
    const type = UserHelpers.isUserType(storedType) ? storedType : undefined;

    useEffect(() => {
        setInitialized(true);
    });

    return { initialized, email, referrer, type, setEmail, setReferrer, setType };
};

export { useLocalUserInfo };
